import { useEffect, useState, useCallback } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useLocations() {
  const [locations, setLocations] = useState([]);
  const { activeLocation, chooseLocation } = useAuth();
  useEffect(() => {
    api.get("/locations").then(({ data }) => {
      setLocations(data);
      if (data.length && (!activeLocation || !data.find((l) => l.id === activeLocation))) {
        chooseLocation(data[0].id);
      }
    }).catch(() => {});
  }, []); // eslint-disable-line
  return { locations, activeLocation, chooseLocation };
}

export function LocationSelect({ allOption = false }) {
  const { locations, activeLocation, chooseLocation } = useLocations();
  return (
    <Select value={activeLocation || (allOption ? "all" : "")} onValueChange={(v) => chooseLocation(v === "all" ? null : v)}>
      <SelectTrigger data-testid="location-select" className="h-10 w-full max-w-[220px] bg-white">
        <SelectValue placeholder="Selecciona local" />
      </SelectTrigger>
      <SelectContent>
        {allOption && <SelectItem value="all">Todos los locales</SelectItem>}
        {locations.map((l) => <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
